export default __webpack_public_path__ + "static/media/classtrack_f3.bc0ff18a.png";